import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';

export const dividerTheme = {
  MuiDivider: {
    styleOverrides: {
      root: {
        border: 'none',
        backgroundColor: tokens.colorSurfaceVariant,
        width: '100%',
        height: 1,
        '&.MuiDivider-withChildren': {
          display: 'flex',
          height: 'auto',
          backgroundColor: 'transparent',
          '&::before, &::after': {
            height: 1,
            backgroundColor: tokens.colorSurfaceVariant
          },
          '.MuiDivider-wrapper': {
            paddingInline: 8
          }
        },
        variants: [
          {
            props: { orientation: 'vertical' },
            style: {
              width: 1,
              height: 'unset'
            }
          }
        ]
      }
    }
  }
} satisfies Components;
